import React from 'react'
import "./stylesheet/intro.css";
import "./stylesheet/mobilesheet/introM.css"
import Typewriter from 'typewriter-effect';
import Button from './button';

const Intro = () => {
  return (
    <>
    <section className='first'><div className="outerBox">
  
        <div className="infoBox">
        <div className="insideinfoBox">
          <div className="mainInfo">
            <p className='hello'>Hello, My Name is </p>
            <span className='myName'>Umang Sahu</span>
            <small>Front-End Developer</small>
            <span className="typingText">I can Build &nbsp;
            <Typewriter
  options={{
    strings: ['Beautiful UI', 'React Web App', 'Interactive design', 'Responsive Design'],
    autoStart: true,
    loop: true,
    pauseFor:1000
  }}
/>
</span>
            <p className="grey">
              Freelancer web developer Based In India
            </p>
          </div>
          <Button link={"link"} title={"Meeting"} subtext={"Want to scheduled"} />
          </div>
          <div className="image"></div>
       
      </div>

      <div className="bgBox">
        <div className="insidebgBox"></div>
      </div>
    </div>
    </section>
  
    </>
  )
}

export default Intro